import { tenantApi } from '@shared/api/tenantApi';
import { unwrap, unwrapList } from '@shared/api/unwrap';

export interface MemberContact {
  member_contact_id: string;
  member_id: string;
  display_name: string;
  phone?: string | null;
  email?: string | null;
  national_id?: string | null;
  id_type?: string | null;
  gender?: string | null;
  date_of_birth?: string | null;
  notes?: string | null;
  is_active?: boolean;
  created_at?: string | null;
  updated_at?: string | null;
}

export interface MemberContactPayload {
  display_name: string;
  phone?: string | null;
  email?: string | null;
  national_id?: string | null;
  id_type?: string | null;
  gender?: string | null;
  date_of_birth?: string | null;
  notes?: string | null;
  metadata?: Record<string, unknown> | null;
}

export type MemberContactUpdatePayload = Partial<MemberContactPayload> & {
  is_active?: boolean;
};

const BASE = '/public/me/member-contacts';

export async function fetchMemberContacts(): Promise<MemberContact[]> {
  const { data } = await tenantApi.get(BASE);
  return unwrapList<MemberContact>(data);
}

export async function createMemberContact(payload: MemberContactPayload): Promise<MemberContact> {
  const { data } = await tenantApi.post(BASE, payload);
  return unwrap<MemberContact>(data);
}

export async function updateMemberContact(
  id: string,
  payload: MemberContactUpdatePayload,
): Promise<MemberContact> {
  const { data } = await tenantApi.patch(`${BASE}/${encodeURIComponent(id)}`, payload);
  return unwrap<MemberContact>(data);
}

export async function deleteMemberContact(id: string): Promise<void> {
  await tenantApi.delete(`${BASE}/${encodeURIComponent(id)}`);
}
